import { TReduxActions } from '../../actions';
import { EAuthenticationActionType, TAuthenticationActions } from '../../actions/authentication';
import { EChatModalActionType } from '../../actions/chatModal';
import { IChatModal } from '../../types/chatModal';

const defaultState: IChatModal = {
  isOpen: false,
  gaLabel: undefined,
  offer: null,
  defaultMessage: null,
  openAfterAuth: false,
};

export function chatModalReducer(
  state: IChatModal = defaultState,
  action: TReduxActions | TAuthenticationActions,
): IChatModal {
  switch (action.type) {
    case EChatModalActionType.Open: {
      return {
        ...state,
        ...action.payload,
        isOpen: true,
      };
    }

    case EChatModalActionType.Close: {
      return { ...defaultState };
    }

    case EChatModalActionType.OpenAfterAuth:
      return {
        ...state,
        ...action.payload,
        openAfterAuth: true,
      };

    case EAuthenticationActionType.Succeed: {
      if (!state.openAfterAuth) {
        return state;
      }

      return {
        ...state,
        isOpen: true,
        openAfterAuth: false,
      };
    }

    case EAuthenticationActionType.Cancelled:
      return {
        ...state,
        openAfterAuth: false,
      };
  }

  return state;
}
